import "./styles.scss";
import React from "react";

interface TypeRound {
  content: string;
}
function Round(props: TypeRound) {
  const { content } = props;

  return (
    <div className="wrapper-round">
      <p className="round-value">{content}</p>
    </div>
  );
}

export default Round;
